export enum AccountingType {
    BillingLetter = 1,
    Approval = 2,
    Refund = 3,
    PurchaseOrder = 4
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/AccountingBlockType.ts